import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useI18n } from 'vue-i18n'
  import Input from '@/components/UI/Input.vue'
  import EyeIcon from '@/assets/EyeIcon.vue'
  

  // Types
  import { FormValues, ShowPasswords, UpdateFn, ValidationFields, PASSWORD_LENGTH } from './EditPassword';

  /**
   * Props Definitions
   */
  interface Props {
    updateFn: UpdateFn,
    formValues: FormValues,
    invalidFields: ValidationFields
    showErrors: boolean
    showPasswords: ShowPasswords
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'PasswordFields',
  props: {
    updateFn: { type: Function },
    formValues: {},
    invalidFields: {},
    showErrors: { type: Boolean },
    showPasswords: {}
  },
  emits: [
    'togglePasswordVisibility',
  ],
  setup(__props: any) {

  /**
   * Imports and Dependencies
   */
  const props = __props
  
  /**
   * Emitted Events
   */
   


  // Methods
  const getConfirmErrorMessage = (): string => {
    // Default
    let message = t('loginRegister.contacts_password_format_lenght')

    // Display different error if not equal
    if(props.formValues.confirmPassword !== props.formValues.newPassword) {
      message = t('loginRegister.contacts_passwords_dont_match')
    } 

    return message
  }

  /**
   * Localization
   */
  const { t } = useI18n()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(Input, {
        value: _ctx.formValues.currentPassword,
        onInput: _cache[1] || (_cache[1] = (value) => _ctx.updateFn('currentPassword', value)),
        placeholder: _unref(t)('profile.currentPasswordPlaceholder'),
        error: _unref(t)('loginRegister.contacts_password_format_lenght'),
        showError: _ctx.showErrors && _ctx.invalidFields.has('currentPassword'),
        inputType: _ctx.showPasswords.current ? 'text' : 'password',
        required: ""
      }, {
        after: _withCtx(() => [
          _createVNode(EyeIcon, {
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('togglePasswordVisibility', 'current')), ["stop"])),
            color: _ctx.showPasswords.current ? '#000000' : '#CED4DA'
          }, null, 8, ["color"])
        ]),
        _: 1
      }, 8, ["value", "placeholder", "error", "showError", "inputType"]),
      _createVNode(Input, {
        value: _ctx.formValues.newPassword,
        onInput: _cache[3] || (_cache[3] = (value) => _ctx.updateFn('newPassword', value)),
        placeholder: _unref(t)('profile.newPasswordPlaceholder'),
        error: _unref(t)('loginRegister.contacts_password_format_lenght'),
        showError: _ctx.showErrors && _ctx.invalidFields.has('newPassword'),
        inputType: _ctx.showPasswords.new ? 'text' : 'password',
        required: ""
      }, {
        after: _withCtx(() => [
          _createVNode(EyeIcon, {
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('togglePasswordVisibility', 'new')), ["stop"])),
            color: _ctx.showPasswords.new ? '#000000' : '#CED4DA'
          }, null, 8, ["color"])
        ]),
        _: 1
      }, 8, ["value", "placeholder", "error", "showError", "inputType"]),
      _createVNode(Input, {
        value: _ctx.formValues.confirmPassword,
        onInput: _cache[5] || (_cache[5] = (value) => _ctx.updateFn('confirmPassword', value)),
        placeholder: _unref(t)('profile.confirmPasswordPlaceholder'),
        error: getConfirmErrorMessage(),
        showError: _ctx.showErrors && _ctx.invalidFields.has('confirmPassword'),
        inputType: _ctx.showPasswords.confirm ? 'text' : 'password',
        required: ""
      }, {
        after: _withCtx(() => [
          _createVNode(EyeIcon, {
            onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.$emit('togglePasswordVisibility', 'confirm')), ["stop"])),
            color: _ctx.showPasswords.confirm ? '#000000' : '#CED4DA'
          }, null, 8, ["color"])
        ]),
        _: 1
      }, 8, ["value", "placeholder", "error", "showError", "inputType"])
    ])
  ]))
}
}

})